<div class="row">
  <div class="col-12 col-md-6" *ngIf="!filePath">
    <div class="bg-light d-flex h-100 align-items-center justify-content-center p-5 cursor-pointer" (click)="selectMediaModal.show(); initGallery = true;">
      <p id="featuredImageHelp" class="form-text text-muted text-center">
        <i class="fas fa-photo-video fa-lg"></i><br>
        <span class="text-primary" href="javascript:;">Seleziona un file dalla gallery</span>
      </p>
    </div>
  </div>
  <div class="col-12 col-md-6" *ngIf="!filePath">
    <div class="bg-light p-3">
      <div>
        <angular-file-uploader
            [config]="afuConfig"
            (ApiResponse)="DocUpload($event)">
        </angular-file-uploader>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div
      class="image-preview"
      [style.backgroundImage]="fileImage()"
      *ngIf="filePath"
      (click)="detachFile()">
    </div>
    {{file ? file.title : filePath}}
  </div>
</div>
<app-ui-modal #selectMediaModal [hideFooter]="true" [dialogClass]="'modal-lg'">
    <div class="app-modal-header">
      <h5 class="modal-title">Galleria Media</h5>
      <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="selectMediaModal.hide(); initGallery = false;"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="app-modal-body">
      <app-select-media *ngIf="initGallery" [formatsAllowed]="formatsAllowed" [newUpdatedMedia]="newUpdatedMedia" (onFileSelect)="setFile($event)"></app-select-media>
    </div>
</app-ui-modal>


